import cx from 'classnames';
import * as React from 'react';

import './styles/TableRow.scss';

type Props = {
  active?: boolean;
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
} & React.HTMLProps<HTMLTableRowElement>;

export default function TableRow({ active, children, className, hoverable, ...others }: Props) {
  return (
    <tr
      {...others}
      data-test-selector="table-row"
      className={cx(
        'TableRow',
        active && 'TableRow--active',
        hoverable && 'TableRow--hoverable',
        className
      )}>
      {children}
    </tr>
  );
}
